import { createTriggerResource } from '@magicdoorinc/ui';
import { getOwnerName } from '~/components/owner/utils';
import { createMagicDoorContext } from '~/contexts/utils';
import { OwnersRepository } from '~/repositories/ownersRepository';
import { PortfolioRepository } from '~/repositories/portfolioRepository';
import { PropertiesRepository } from '~/repositories/propertiesRepository';
import { ReportRepository } from '~/repositories/reportRepository';

const repo = new ReportRepository();
const propertyRepo = new PropertiesRepository();
const ownerRepo = new OwnersRepository();
const portfolioRepo = new PortfolioRepository();
export const [ReportsProvider, useReports] = createMagicDoorContext('Reports', () => {
  const [balanceSheetReport, getBalanceSheetReport] = createTriggerResource(repo.getBalanceSheetReport.bind(repo));
  const [cashFlowReport, getCashFlowReport] = createTriggerResource(repo.getCashFlowStatementReport.bind(repo));
  const [generalLedgerReport, getGeneralLedgerReport] = createTriggerResource(repo.getGeneralLedgerReport.bind(repo));
  const [incomeStatementReport, getIncomeStatementReport] = createTriggerResource(repo.getIncomeStatementReport.bind(repo));
  const [ownerStatementReport, getOwnerStatementReport, ownerStatementReportActions] = createTriggerResource(
    repo.getOwnerStatementReport.bind(repo)
  );
  const [propertyDirectoryReport, getPropertyDirectoryReport] = createTriggerResource(repo.getPropertyDirectoryReport.bind(repo));
  const [inventoryReport, getInventoryReport] = createTriggerResource(repo.getInventoryReport.bind(repo));
  const [ownerDirectoryReport, getOwnerDirectoryReport] = createTriggerResource(repo.getOwnerDirectoryReport.bind(repo));
  const [tenantDirectoryReport, getTenantDirectoryReport] = createTriggerResource(repo.getTenantDirectoryReport.bind(repo));
  const [bankAccountActivityReport, getBankAccountActivityReport] = createTriggerResource(repo.getBankAccountActivityReport.bind(repo));
  const [leaseUnpaidBillsReport, getLeaseUnpaidBillsReport] = createTriggerResource(repo.getLeaseUnpaidBillsReport.bind(repo));
  const [delinquencyReport, getDelinquencyReport] = createTriggerResource(repo.getDelinquencyReport.bind(repo));
  const [propertyReserveReport, getPropertyReserveReport] = createTriggerResource(repo.getPropertyReserveReport.bind(repo));
  const [accountsPayableReport, getAccountsPayableReport] = createTriggerResource(repo.getAccountsPayableReport.bind(repo));
  const [leaseMagicTagsReport, getLeaseMagicTagsReport] = createTriggerResource(repo.getLeaseMagicTagsReport.bind(repo));
  const [prepaidRentReport, getPrepaidRentReport] = createTriggerResource(repo.getPrepaidRentReport.bind(repo));
  const [lateFeesReport, getLateFeesReport] = createTriggerResource(repo.getLateFeesReport.bind(repo));
  const [rentPaymentsReport, getRentPaymentsReport] = createTriggerResource(repo.getRentPaymentsReport.bind(repo));

  const dealMultipleFilter = (data: string[], current: string) => {
    if (current === 'All') return [];

    if (data?.includes('All')) return data.filter((item) => item !== 'All');
    return data;
  };

  const getFilterDisplay = async (propertyIds?: string, portfolioIds?: string) => {
    let propertiesStr = '';
    let portfoliosStr = '';

    if (propertyIds) {
      const property = await propertyRepo.batchGetPropertyByIds(propertyIds.split(','));
      propertiesStr = property.map((p) => p.name).join(', ') ?? '';
    }

    if (portfolioIds) {
      const portfolio = await portfolioRepo.batchGetPortfolioByIds(portfolioIds.split(','));
      portfoliosStr = portfolio?.map((p) => p.name).join(', ') ?? '';
    }
    return { propertiesStr, portfoliosStr };
  };

  const getSelectedOwners = async (ownerIds?: string) => {
    if (!ownerIds) return null;
    const owners = await ownerRepo.batchGetOwnersByIds(ownerIds.split(','));
    return owners.map((owner) => getOwnerName(owner)).join(', ');
  };

  const [rentRollReport, getRentRollReport] = createTriggerResource(repo.getRentRollReport.bind(repo));

  return {
    cashFlowReport,
    getCashFlowReport,
    generalLedgerReport,
    getGeneralLedgerReport,
    balanceSheetReport,
    getBalanceSheetReport,
    incomeStatementReport,
    getIncomeStatementReport,
    dealMultipleFilter,
    rentRollReport,
    getRentRollReport,
    propertyDirectoryReport,
    getPropertyDirectoryReport,
    inventoryReport,
    getInventoryReport,
    ownerDirectoryReport,
    getOwnerDirectoryReport,
    tenantDirectoryReport,
    getTenantDirectoryReport,
    bankAccountActivityReport,
    getBankAccountActivityReport,
    leaseUnpaidBillsReport,
    getLeaseUnpaidBillsReport,
    getFilterDisplay,
    getSelectedOwners,
    delinquencyReport,
    getDelinquencyReport,
    propertyReserveReport,
    getPropertyReserveReport,
    accountsPayableReport,
    getAccountsPayableReport,
    ownerStatementReport,
    getOwnerStatementReport,
    leaseMagicTagsReport,
    getLeaseMagicTagsReport,
    ownerStatementReportActions,
    prepaidRentReport,
    getPrepaidRentReport,
    lateFeesReport,
    getLateFeesReport,
    rentPaymentsReport,
    getRentPaymentsReport,
  };
});
